module.exports = __webpack_public_path__ + "img/pistol.0821d966.png";